import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Main from "../../components/Layout/Main";
import { Helmet } from 'react-helmet';
import CoverImage from '../../components/CoverImage';
import TextBlock from '../../components/TextBlock/TextBlock';
import PressQuotes from '../../components/PressQuotes/PressQuotes';

const Press = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query PressQuery {
      markdownRemark(frontmatter: { pageId: { eq: "press-page" } }) {
        frontmatter {
          components {
            type
            id
            deeplink
            variant
            content {
              video {
                src
                loop
                autoplay
                controls
              }
              copy {
                leader
                caption
                trailer
                quotes {
                  line
                  source
                }
                headlines {
                  line
                }
                scriptHeadline {
                  line
                }
              }
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  const availComponents = {
    CoverImage,
    TextBlock,
    PressQuotes
  }

  const renderComponents = () => {
    const components = markdownRemark.frontmatter.components;
    let hydratedComponents = [];
    components.forEach((component, i) => {
      // console.log(component.type, component.content)
      const ComponentRef = availComponents[component.type]
      const deeplinkId = component.deeplink ? component.id : '';
      hydratedComponents.push(<ComponentRef key={i} id={deeplinkId} variant={component.variant} {...component.content}/>)
    })
    return hydratedComponents
  }

  return (
    <Main>
      <Helmet>
        <body className="page press-page" />
      </Helmet>
      {renderComponents()}
    </Main>
  );
}

export default Press
